var exports = {
  "In": "TextualAttachmentPreview.module__textualPreview___UGRmWG",
  "KR": "TextualAttachmentPreview.module__previewSurface___UGRmWG",
  "cA": "TextualAttachmentPreview.module__previewActions___UGRmWG",
  "wL": "TextualAttachmentPreview.module__previewActionsVisible___UGRmWG",
  "VA": "TextualAttachmentPreview.module__previewActionButton___UGRmWG" + " " + __webpack_require__(77126)["AS"],
  "nJ": "TextualAttachmentPreview.module__copyIcon___UGRmWG",
  "fs": "TextualAttachmentPreview.module__inlinePreviewSurface___UGRmWG",
  "vd": "TextualAttachmentPreview.module__previewViewport___UGRmWG",
  "uL": "TextualAttachmentPreview.module__previewViewportCollapsed___UGRmWG",
  "q4": "TextualAttachmentPreview.module__previewViewportExpanded___UGRmWG",
  "Nv": "TextualAttachmentPreview.module__csvTableViewport___UGRmWG",
  "rV": "TextualAttachmentPreview.module__csvTableMarkup___UGRmWG",
  "uT": "TextualAttachmentPreview.module__previewCode___UGRmWG",
  "O9": "TextualAttachmentPreview.module__previewCodeWrap___UGRmWG",
  "VP": "TextualAttachmentPreview.module__previewError___UGRmWG",
  "Ml": "TextualAttachmentPreview.module__loadingState___UGRmWG",
  "qr": "TextualAttachmentPreview.module__footer___UGRmWG",
  "X1": "TextualAttachmentPreview.module__expandButton___UGRmWG" + " " + __webpack_require__(77126)["AS"],
  "eO": "TextualAttachmentPreview.module__expandIcon___UGRmWG",
  "t2": "TextualAttachmentPreview.module__expandIconExpanded___UGRmWG",
  "qt": "TextualAttachmentPreview.module__fileSection___UGRmWG",
  "gM": "TextualAttachmentPreview.module__fileMeta___UGRmWG",
  "Md": "TextualAttachmentPreview.module__fileName___UGRmWG",
  "Ov": "TextualAttachmentPreview.module__fileSize___UGRmWG",
  "zt": "TextualAttachmentPreview.module__footerActions___UGRmWG",
  "uH": "TextualAttachmentPreview.module__controlButton___UGRmWG" + " " + __webpack_require__(77126)["AS"],
  "RJ": "TextualAttachmentPreview.module__languagePositioner___UGRmWG",
  "tP": "TextualAttachmentPreview.module__languagePopup___UGRmWG",
  "Nl": "TextualAttachmentPreview.module__languageSearchWrap___UGRmWG",
  "nb": "TextualAttachmentPreview.module__languageSearchInput___UGRmWG",
  "qm": "TextualAttachmentPreview.module__languageEmpty___UGRmWG",
  "xl": "TextualAttachmentPreview.module__languageList___UGRmWG",
  "O6": "TextualAttachmentPreview.module__languageItem___UGRmWG",
  "d6": "TextualAttachmentPreview.module__languageItemHighlighted___UGRmWG",
  "J6": "TextualAttachmentPreview.module__languageItemSelected___UGRmWG",
  "_s": "TextualAttachmentPreview.module__languageOptionCanonical___UGRmWG",
  "xu": "TextualAttachmentPreview.module__languageItemIndicator___UGRmWG",
  "lh": "TextualAttachmentPreview.module__languageOptionContent___UGRmWG",
  "XO": "TextualAttachmentPreview.module__languageOptionCode___UGRmWG",
  "CR": "TextualAttachmentPreview.module__modalRoot___UGRmWG",
  "Ij": "TextualAttachmentPreview.module__modalLayout___UGRmWG",
  "S3": "TextualAttachmentPreview.module__modalBody___UGRmWG",
  "fn": "TextualAttachmentPreview.module__modalPreviewSurface___UGRmWG",
  "CM": "TextualAttachmentPreview.module__previewViewportFill___UGRmWG",
  "v6": "TextualAttachmentPreview.module__previewCodeFill___UGRmWG",
};

module.exports = exports;
